module.exports = __webpack_public_path__ + "img/psn18q7aifg1w4msngnu3j1t712yu4yio0f7ced35-5cce-4c9f-a972-2e62af8f7842.7590b118.png";